export interface IMapBaseOverlayEvents {
  add: undefined;
  remove: undefined;

  zIndexChange: number;
  opacityChange: number;
  clickableChange: boolean;

  click: MouseEvent;
  dblclick: MouseEvent;
  rightclick: MouseEvent;
  mouseover: MouseEvent;
  mouseout: MouseEvent;
}
